import VueGeolocation from 'vue-browser-geolocation';
import Vue from 'vue';

Vue.use(VueGeolocation);